var ButtonType;
(function (ButtonType) {
    ButtonType["BUTTON"] = "button";
    ButtonType["RESET"] = "reset";
    ButtonType["SUBMIT"] = "submit";
})(ButtonType || (ButtonType = {}));
export default ButtonType;
//# sourceMappingURL=button-type.js.map